import * as React from 'react';

import * as styles from './LayoutOfferGroups.css';

export const LayoutOfferGroups: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <noindex>
      <div className={styles['container']}>{children}</div>
    </noindex>
  );
};
